import { Suspense, useMemo, useEffect } from "react";
import { CssBaseline } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// project imports
import NavigationScroll from "./utils/NavigationScroll";
import MainRoute from "./routes/index.js";
// themes
import getTheme from "./themes/index.js";
import SessionExpiredModal from "./components/SessionExpiredModal";
import { useSessionHandler } from "./hooks/useSessionHandler";
import { useTheme } from "./hooks/useTheme";
import { usePageTracking } from "./hooks/usePageTracking";
import { initGA } from "./utils/googleAnalytics";
// import VersionDebug from "./components/DebugPanel/VersionDebug.js";

// Importar estilos de tema
import "./assets/styles/themes.css";

function App() {
  const { showSessionExpiredModal, handleRedirectToLogin } =
    useSessionHandler();
  
  const { effectiveTheme } = useTheme();
  
  const theme = useMemo(() => getTheme(effectiveTheme), [effectiveTheme]);

  // Inicializar Google Analytics
  useEffect(() => {
    initGA();
  }, []);

  // Rastrear visualizações de página
  usePageTracking();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline>
          <NavigationScroll>
            <Suspense fallback={<h1>Loading Components...</h1>}>
              <MainRoute />

              {/* <VersionDebug /> */}
            </Suspense>
          </NavigationScroll>
        </CssBaseline>
        {/* Modal de sessão expirada */}
        <SessionExpiredModal
          open={showSessionExpiredModal}
          onRedirect={handleRedirectToLogin}
        />

        {/* Container para toasts */}
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme={effectiveTheme}
        />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
